import React, { useEffect } from 'react'
import PageCard from '../../../common/PageCard'
import Page from '../../../common/Page'
import $t from '../../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../../actions'
import { useParams } from 'react-router'

import './IdCardFileView.css'

const IdCardFileView = () => {
  const dispatch = useDispatch()
  const { id } = useParams()

  const { memberCardFile, isMemberCardLoading } = useSelector(
    state => state.nhMember
  )

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.MEMBER_CARD_REQUESTED, {
        patientId: id,
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isMemberCardLoading && !memberCardFile) {
    return (
      <PageCard className="id-card-file-view-page-card" enableBack={true}>
        <Page
          className="id-cards-file-view-page"
          hideAlertBanner={true}
          displayManageFamily={false}
        >
          <div className="id-card-empty">
            <div className="id-card-empty-text semi-bold">
              {$t('pages.idCards.emptyFileTitle')}:
            </div>
            <div className="id-card-empty-text">
              {$t('pages.idCards.emptyFileSubtitle')}
            </div>
          </div>
        </Page>
      </PageCard>
    )
  }

  return (
    <Page
      loading={isMemberCardLoading}
      className="id-cards-file-view-page-pdf"
      hideAlertBanner={true}
      displayManageFamily={false}
    >
      <iframe
        src={memberCardFile}
        height="100%"
        width="100%"
        type="application/pdf"
        title="id card"
        className="id-card-file-view-iframe"
      ></iframe>
    </Page>
  )
}

export default IdCardFileView
